// `nav`: how the screen being shown was reached. 'push' (go to another path), 'replace',
// 'same' (go to the path on show), 'pop' (Back or Forward) or 'load' (the first screen).
export const state = { user: null, needsSetup: false, flash: '', nav: 'load' };
